import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './createShipmentModalComponent.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import createShipmentModalImage from '../../../src/assets/images/createShipmentModalImage.svg'
import createShipmentModalBackground from '../../../src/assets/images/createShipmentModalBackground.svg'


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const CreateShipmentModalComponent = ({ isOpen, handleClose, handleCreate }) => {
  return (
    <React.Fragment >
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        PaperProps={{
          style: {
            maxWidth: '370px', // Adjust the maxWidth as needed
            width: '100%',
            maxHeight: '360px'
          },
        }}
        maxHeight="300" // Adjust the maxHeight as needed

      >
        <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
          {/* Modal title */}
          <div className='createShipmentModalImagediv'>

            <img
              className='createShipmentModalImage'
              src={createShipmentModalBackground}
            />
            <img
              className='createShipmentModalImage1'
              src={createShipmentModalImage}
            />
            <h4 className='subHeadingForCreateShipmentModal'>
              Please check the SHIPMENT details entered before proceeding.
            </h4>
          </div>
          <div>
            <hr style={{ width: "100%" }}>
            </hr>
          </div>
          <div >
            <Button className='backButton' onClick={handleClose}>Go back to edit</Button>
            <Button className='createButton' onClick={handleCreate}>Create Shipment</Button>
          </div>
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default CreateShipmentModalComponent;